module.exports = Em.Handlebars.compile("{{{html}}}\n");